import { use_component_is_mounted } from './use_component_is_mounted';

export function use_component_is_mounted_0(on_mounted: VoidFunction = () => {}) {
  return use_component_is_mounted(0, on_mounted);
}
